module.exports = __webpack_public_path__ + "static/media/ic_message_deactivate.81aac71c.svg";